module.exports = __webpack_public_path__ + "static/about_system_chat-3558d34c2bad9820e113817b16eab74b.png";